export const BLOCK_TYPE_FACTS_LIST = 'facts-list';
